import Vue from "vue";
import Router from "vue-router";
import Index from "./views/Index.vue";

Vue.use(Router);

const originalPush = Router.prototype.push;

Router.prototype.push = function push(location, onComplete, onAbort) {
  const result = originalPush.call(this, location, onComplete, onAbort);
  if (result) {
    return result.catch((err) => {
      if (err.name !== "NavigationDuplicated") {
        throw err;
      }
    });
  }
  return result;
};

const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location, onComplete, onAbort) {
  const result = originalReplace.call(this, location, onComplete, onAbort);
  if (result) {
    return result.catch((err) => {
      if (err.name !== "NavigationDuplicated") {
        throw err;
      }
    });
  }
  return result;
};

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Index,
      meta: { auth: true },
    },
    {
      path: "/category",
      name: "Category",
      component: () => import("./views/category/index.vue"),
      meta: { auth: true },
    },
    {
      path: "/category/:id",
      name: "open",
      component: () => import("./views/category/open.vue"),
      meta: { auth: true },
    },
    {
      path: "/account",
      name: "account",
      component: () => import("./components/pages/Account.vue"),
      meta: { auth: true },
    },
    {
      path: "/risk/:id",
      name: "risk",
      props: true,
      component: () => import("./views/risks/Risk.vue"),
      meta: { auth: true },
    },
    {
      path: "/login",
      name: "login",
      component: require("./components/pages/Login.vue").default,
      meta: { auth: false },
    },
    {
      path: "/register",
      name: "register",
      component: require("./components/pages/Register.vue").default,
      meta: { auth: false },
    },
    {
      path: "/404",
      name: "error-404",
      component: require("./components/pages/404.vue").default,
    },
    {
      path: "/403",
      name: "error-403",
      component: require("./components/pages/403.vue").default,
    },
    {
      path: "/502",
      name: "error-502",
      component: require("./components/pages/502.vue").default,
    },
    {
      path: "*",
      redirect: "/404",
    },
    {
      path: "/forgot",
      name: "Forgot",
      component: function (resolve) {
        require(["./components/pages/reset.vue"], resolve).default;
      },
    },
    {
      path: "/admin",
      name: "Admin",
      component: () => import("./views/admin/Index.vue"),
      meta: { auth: true },
      children: [
        {
          path: "",
          component: () => import("./views/admin/users.vue"),
        },
        {
          path: "users",
          component: () => import("./views/admin/users.vue"),
        },
        {
          path: "mailing",
          component: () => import("./views/admin/mailing.vue"),
        },
        {
          path: "keys",
          component: () => import("./views/admin/keys.vue"),
        },
        {
          path: "projects",
          component: () => import("./views/admin/AdminProjects.vue"),
        },
      ],
    },
    {
      path: "/mst",
      name: "Mst",
      component: () => import("./views/admin/mst/Index.vue"),
      meta: { auth: true },
      children: [],
    },
  ],
});
